import { useBlockAction } from '@editorHooks'

interface Props {
  actionId: string
  isDirty: boolean
}

/**
 * Registers a block for `actionId` while `isDirty` is true, so subscribers elsewhere
 * (tab/pane switches, navigation, escape handlers) can refuse to proceed until the
 * form is saved or reset. Renders nothing; must live inside the form it tracks.
 */
const FormDirtyBlocker = ({ actionId, isDirty }: Props): null => {
  useBlockAction(actionId, isDirty ? 'provider' : undefined)

  return null
}

export default FormDirtyBlocker
